module.exports = __webpack_public_path__ + "media/test-mode8.51bc8254.mp4";